export default __webpack_public_path__ + "static/media/mycollaboIcon.46115864.svg";